var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Document-Icon",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F3F3F3",
    x: 0,
    y: 0,
    width: 64,
    height: 64,
    rx: 8
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon_File_Sharing",
    transform: "translate(20.000000, 17.000000)",
    stroke: "#263238",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Document_Front",
    transform: "translate(0.067407, 0.000000)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 13,
    x2: 17,
    y2: 13,
    id: "Stroke-15",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 19,
    x2: 17,
    y2: 19,
    id: "Stroke-15",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 25,
    x2: 17,
    y2: 25,
    id: "Stroke-15",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 7,
    x2: 13,
    y2: 7,
    id: "Stroke-13",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.32,0 L24,9.6 L24,30 C24,31.1045695 23.1045695,32 22,32 L2,32 C0.8954305,32 1.3527075e-16,31.1045695 0,30 L0,2 C-1.3527075e-16,0.8954305 0.8954305,2.02906125e-16 2,0 L16.32,0 L16.32,0 Z",
    id: "Path",
    strokeLinejoin: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentIcon);
export default __webpack_public_path__ + "static/media/document-icon.70831eb2.svg";
export { ForwardRef as ReactComponent };